

export const ExampleDashboard = () => {
  return <div>dashboard example</div>;
};